import { Router } from '@angular/router';
import { Auth } from '../auth/auth.service';
import { Role } from '../auth/role';
var MainMenuComponent = /** @class */ (function () {
    function MainMenuComponent(auth, _router) {
        this.auth = auth;
        this._router = _router;
        this.expanded = false;
    }
    Object.defineProperty(MainMenuComponent.prototype, "ariaExpanded", {
        get: function () {
            return this.expanded ? 'true' : 'false';
        },
        enumerable: true,
        configurable: true
    });
    MainMenuComponent.prototype.ngOnDestroy = function () {
        this.tokenSubscription && this.tokenSubscription.unsubscribe();
    };
    MainMenuComponent.prototype.ngOnInit = function () {
        this.initMainMenu();
        this.tokenSubscription = this.auth.tokenChange.subscribe(this.initMainMenu.bind(this));
    };
    MainMenuComponent.prototype.doAction = function (item, event) {
        if (item.action && typeof item.action === 'function') {
            item.action(item, event);
        }
        else {
            this.collapse();
        }
    };
    MainMenuComponent.prototype.collapse = function () {
        this.expanded = false;
        this.mainMenu.openedSubmenu = null;
        this.mainMenu.openedSubSubmenu = null;
    };
    MainMenuComponent.prototype.logout = function () {
        this.auth.logOut();
        this.collapse();
        this._router.onSameUrlNavigation = 'reload';
        return this._router.navigate([this._router.url]);
    };
    MainMenuComponent.prototype.showSubmenu = function (menuItem) {
        if (this.mainMenu.openedSubmenu === menuItem.submenu) {
            this.mainMenu.openedSubmenu = null;
            this.mainMenu.openedSubSubmenu = null;
        }
        else {
            this.mainMenu.openedSubmenu = menuItem.submenu;
        }
    };
    MainMenuComponent.prototype.showSubSubmenu = function (menuItem) {
        if (this.mainMenu.openedSubSubmenu === menuItem.submenu) {
            this.mainMenu.openedSubSubmenu = null;
        }
        else {
            this.mainMenu.openedSubSubmenu = menuItem.submenu;
        }
    };
    MainMenuComponent.prototype.initMainMenu = function () {
        this.mainMenu = {
            menus: [
                {
                    cssClass: 'mr-auto',
                    items: [
                        {
                            id: 'main-menu-who-we-are',
                            // routerLink: ['/kik-vagyunk'],
                            action: this.showSubmenu.bind(this),
                            label: 'Kik vagyunk?',
                            submenu: {
                                items: [
                                    { routerLink: ['/rolunk'], label: 'Rólunk' },
                                    { routerLink: ['/kapcsolat'], label: 'Kapcsolat' },
                                    { routerLink: ['/komment'], label: 'Üzenj nekünk!' },
                                ]
                            }
                        },
                        {
                            id: 'main-menu-what-we-do',
                            // routerLink: ['/mit-teszunk'],
                            action: this.showSubmenu.bind(this),
                            label: 'Mit teszünk?',
                            submenu: {
                                items: [
                                    {
                                        id: 'main-menu-programs',
                                        // routerLink: ['/programok'],
                                        action: this.showSubSubmenu.bind(this),
                                        label: 'Programok',
                                        submenu: {
                                            items: [
                                                { routerLink: ['/programok/istentiszteletek'], label: 'Istentiszteletek' },
                                                { routerLink: ['/programok/gyerekfogi'], label: 'Gyermek foglalkozások' },
                                                { routerLink: ['/programok/ifi'], label: 'Ifjúsági alkalmak' },
                                                { routerLink: ['/programok/hazasrandi'], label: 'Házasoknak' },
                                                { routerLink: ['/programok/hazicsoportok'], label: 'Házicsoportok' },
                                                { routerLink: ['/programok/taborok'], label: 'Táborok, konferenciák' },
                                            ]
                                        }
                                    },
                                    {
                                        id: 'main-menu-missions',
                                        // routerLink: ['/missziok'],
                                        action: this.showSubSubmenu.bind(this),
                                        label: 'Missziók',
                                        submenu: {
                                            items: [
                                                { routerLink: ['/missziok/bab'], label: 'Báb csapat' },
                                                { routerLink: ['/missziok/pantomim'], label: 'Pantomim' },
                                                { routerLink: ['/missziok/plantalt'], label: 'Plántált gyülekezeteink' },
                                                { routerLink: ['/missziok/misszionariusok'], label: 'Misszionáriusaink' },
                                            ]
                                        }
                                    },
                                    { routerLink: ['/bibliaiskola'], label: 'Bibliaiskola' },
                                ]
                            }
                        },
                        {
                            id: 'main-menu-records',
                            // routerLink: ['/felvetelek'],
                            action: this.showSubmenu.bind(this),
                            label: 'Felvételek',
                            submenu: {
                                items: [
                                    {
                                        routerLink: ['/felvetelek/tanitasok'],
                                        label: 'Tanítások',
                                        icon: 'fa-microphone'
                                    },
                                    {
                                        routerLink: ['/felvetelek/sorozatok'],
                                        label: 'Sorozatok',
                                        icon: 'fa-files-o'
                                    },
                                ]
                            }
                        },
                        {
                            id: 'main-menu-events',
                            // routerLink: ['/tartalmak'],
                            action: this.showSubmenu.bind(this),
                            label: 'Tartalmak',
                            submenu: {
                                items: [
                                    {
                                        routerLink: ['/tartalmak/hirek'],
                                        label: 'Hírek',
                                        icon: 'fa-newspaper-o'
                                    },
                                ]
                            }
                        },
                        {
                            routerLink: ['/barataink'],
                            label: 'Barátaink'
                        },
                    ]
                },
                {
                    cssClass: 'ml-auto',
                    items: this.getLoggedInMenu()
                },
                this.getUserMenu()
            ]
        };
    };
    MainMenuComponent.prototype.getLoggedInMenu = function () {
        var loggedInMenu = [this.getWorshipMenu()];
        if (this.auth.hasAnyRoleOf(Role.ADMIN, Role.EMAIL_SENDER, Role.PUBLISHER, Role.AUDIO_VIDEO, Role.MODERATOR)) {
            loggedInMenu.push(this.getAdministrationMenu());
        }
        return loggedInMenu;
    };
    MainMenuComponent.prototype.getWorshipMenu = function () {
        var worshipMenu = {
            id: 'main-menu-worship',
            // routerLink: ['/dicsi/kottak'],
            action: this.showSubmenu.bind(this),
            label: 'Dicsicsapat',
            icon: 'fa-music',
            submenu: {
                cssClass: 'align-right',
                items: [
                    { routerLink: ['/dicsi/kottak'], label: 'Kották', icon: 'fa-file-text-o' },
                ]
            }
        };
        if (this.auth.hasRole(Role.WORSHIP_LEADER)) {
            worshipMenu.submenu.items.push({
                routerLink: ['/dicsi/kottak/uj'],
                label: 'Új kotta',
                icon: 'fa-plus'
            });
            worshipMenu.submenu.items.push({
                routerLink: ['/dicsi/csapat'],
                label: 'Csapat',
                icon: 'fa-users'
            });
        }
        if (this.auth.hasAnyRoleOf(Role.WORSHIP_LEADER, Role.WORSHIPER, Role.AUDIO_VIDEO)) {
            worshipMenu.submenu.items.push({
                routerLink: ['/dicsi/beosztas'],
                label: 'Beosztás',
                icon: 'fa-calendar'
            });
        }
        return worshipMenu;
    };
    MainMenuComponent.prototype.getAdministrationMenu = function () {
        var adminMenu = {
            id: 'main-menu-admin',
            // routerLink: ['/admin'],
            action: this.showSubmenu.bind(this),
            label: 'Adminisztráció',
            submenu: {
                cssClass: 'align-right',
                items: []
            }
        };
        if (this.auth.hasAnyRoleOf(Role.ADMIN, Role.CAMPER)) {
            adminMenu.submenu.items.push({
                routerLink: ['/taborozo/admin'],
                label: 'Táborok',
                icon: 'fa-home'
            });
        }
        if (this.auth.hasRole(Role.PUBLISHER)) {
            adminMenu.submenu.items.push({
                routerLink: ['/admin/tartalmak'],
                label: 'Tartalmak',
                icon: 'fa-newspaper-o'
            });
        }
        if (this.auth.hasRole(Role.AUDIO_VIDEO)) {
            adminMenu.submenu.items.push({
                routerLink: ['/admin/felvetelek'],
                label: 'Felvételek',
                icon: 'fa-microphone'
            });
        }
        if (this.auth.hasRole(Role.EMAIL_SENDER)) {
            adminMenu.submenu.items.push({
                routerLink: ['/email'],
                label: 'Email küldés',
                icon: 'fa-paper-plane-o'
            });
        }
        if (this.auth.hasAnyRoleOf(Role.MODERATOR)) {
            adminMenu.submenu.items.push({
                routerLink: ['/admin/kommentek'],
                label: 'Moderálás',
                icon: 'fa-comment-o'
            });
        }
        if (this.auth.hasRole(Role.ADMIN)) {
            adminMenu.submenu.items.push({
                routerLink: ['/admin/felhasznalok'],
                label: 'Felhasználók',
                icon: 'fa-users'
            });
        }
        return adminMenu;
    };
    MainMenuComponent.prototype.getUserMenu = function () {
        if (this.auth.isLoggedIn()) {
            return {
                items: [
                    {
                        id: 'main-menu-user-menu',
                        // routerLink: ['/felhasznalo/profil'],
                        action: this.showSubmenu.bind(this),
                        label: this.auth.user.nickname || this.auth.user.firstname || this.auth.user.lastname || this.auth.user.email,
                        submenu: {
                            cssClass: 'align-right',
                            items: [
                                {
                                    routerLink: ['/felhasznalo/profil'],
                                    label: 'Profil',
                                    icon: 'fa-user'
                                },
                                {
                                    action: this.logout.bind(this),
                                    label: 'Kilépés',
                                    icon: 'fa-sign-out'
                                }
                            ]
                        }
                    }
                ]
            };
        }
        return {
            cssClass: 'ml-auto mt-3 mt-lg-0',
            items: [
                {
                    routerLink: ['/belepes'],
                    label: 'Belépés',
                    cssClass: 'btn btn-sm btn-outline-secondary mr-lg-2 mb-2 mb-lg-0'
                },
                {
                    routerLink: ['/regisztracio'],
                    label: 'Regisztráció',
                    cssClass: 'btn btn-sm btn-outline-secondary'
                }
            ]
        };
    };
    return MainMenuComponent;
}());
export { MainMenuComponent };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/main-menu/main-menu.component.ts.pre-build-optimizer.js